export default __webpack_public_path__ + "static/media/dotsHorizontal.665fd4fd.svg";